import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, ElementType } from "@easy-email-pro-core/constants";
import {
  HtmlBlockNodeElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<HtmlBlockNodeElement>["defaultData"] = {
  attributes: {},
  data: {
    tagName: "div",
  },
};

export const HtmlBlockNode = createBlock<HtmlBlockNodeElement>({
  get name() {
    return t("HtmlBlockNode");
  },
  defaultData,
  type: ElementType.HTML_BLOCK_NODE,
  create: (payload) => {
    const defaultData: HtmlBlockNodeElement = {
      type: ElementType.HTML_BLOCK_NODE,
      data: {
        tagName: "div",
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.BLOCK_NODE,
  render(params) {
    if (params.mode === "production") {
      return <BasicBlock tag={params.node.data.tagName} params={params} />;
    }
    return (
      <BasicBlock
        tag={params.node.data.tagName || "div"}
        params={{
          ...params,
          node: {
            ...params.node,
            attributes: {
              "element-type": ElementType.HTML_BLOCK_NODE,
              "element-category": ElementCategory.BLOCK_NODE,
              "element-data": encodeURIComponent(
                JSON.stringify(params.node.data)
              ),
              "element-attributes": encodeURIComponent(
                JSON.stringify(params.node.attributes)
              ),
            } as any,
          },
        }}
      />
    );
  },
});
